export function getToken() {
  return localStorage.getItem(process.env.REACT_APP_TOKEN)
}

export function setToken(token) {
  localStorage.setItem(process.env.REACT_APP_TOKEN, token)
}